import { useEffect, useState } from 'react'
import { Keyboard, Platform } from 'react-native'

export function useKeyboardStatus() {
    const [keyboardVisible, setKeyboardVisible] = useState(false)

    useEffect(() => {
        if (Platform.OS != 'android') return
        const showEvent = Platform.OS === 'android' ? 'keyboardDidShow' : 'keyboardWillShow'
        const hideEvent = Platform.OS === 'android' ? 'keyboardDidHide' : 'keyboardWillHide'

        const showListener = Keyboard.addListener(showEvent, () => setKeyboardVisible(true))
        const hideListener = Keyboard.addListener(hideEvent, () => setKeyboardVisible(false))

        return () => {
            showListener.remove()
            hideListener.remove()
        }
    }, [])

    return keyboardVisible
}
